import { Outlet } from "react-router-dom";
import { AdminSidebar } from "./AdminSidebar";
import MobileBottomNav from "./MobileBottomNav";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { useAdminPWA } from "@/hooks/useAdminPWA";

export function AdminLayout() {
  useAdminPWA();
  
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-background">
        <AdminSidebar />
        
        <div className="flex-1 flex flex-col">
          <header className="min-h-[calc(3rem+env(safe-area-inset-top))] md:h-14 border-b flex items-center px-2 md:px-4 sticky top-0 bg-background z-10 pt-[env(safe-area-inset-top)]">
            <SidebarTrigger className="mr-2 md:mr-4" />
            <h1 className="text-base md:text-lg font-semibold">Admin Panel</h1>
          </header>
          
          <main className="flex-1 px-3 py-4 md:p-4 lg:p-6 overflow-auto pb-[calc(5rem+env(safe-area-inset-bottom))] md:pb-6">
            <Outlet />
          </main>
        </div>
        
        <MobileBottomNav />
      </div>
    </SidebarProvider>
  );
}
